import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M0.499994 18C0.499995 8.33501 8.33501 0.499998 18 0.499998C27.665 0.499999 35.5 8.33502 35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33501 35.5 0.499993 27.665 0.499994 18Z\" stroke=\"#454342\"></path><g clip-path=\"url(#clip0_2790_14621)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24.273 17.3743L11.7266 17.3743L11.7266 18.6289L24.273 18.6289L24.273 17.3743Z\" fill=\"#454342\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.8794 23.2813L25.1578 18.0028L19.8794 12.7244L18.9922 13.6116L23.3834 18.0028L18.9922 22.3941L19.8794 23.2813Z\" fill=\"#454342\"></path></g><defs><clipPath id=\"clip0_2790_14621\"><rect width=\"15.0557\" height=\"15.0558\" fill=\"white\" transform=\"matrix(1 8.74228e-08 8.74228e-08 -1 10.4727 25.5273)\"></rect></clipPath></defs>", 3)
  ])))
}
export default { render: render }